import Modal from "global/Modal/Modal"
import { useEffect, useState } from "react"
import { getAPI } from "services/CRUDServices"

function ImageView({ open, setOpen, currentData, isSingle = false }) {
  const [fileUrl, setFileUrl] = useState<string | null>(null)
  const [fileType, setFileType] = useState<string | null>(null)

  useEffect(() => {
    if (!open || !currentData?.receiptPicture) return
    getAPI(
      `${process.env.REACT_APP_BASE_URL}/storage-api/indexed-objects/${currentData?.receiptPicture}/as-file`,
      true,
      undefined,
      "*/*"
    ).then((res) => {
      const contentType =
        res.headers["content-type"] || "application/octet-stream"

      setFileType(contentType)

      const blob = new Blob([res.data], { type: contentType })
      const url = URL.createObjectURL(blob)
      setFileUrl(url)
    })

    return () => {
      if (fileUrl) URL.revokeObjectURL(fileUrl)
    }
  }, [open])

  return (
    <Modal
      visible={open}
      setVisible={setOpen}
      title=""
      className={`w-1/2 mx-auto ${
        fileType?.includes("pdf") ? "min-w-[50rem]" : ""
      } `}
    >
      <div className="flex flex-col gap-8">
        {fileUrl ? (
          fileType?.includes("image") ? (
            <img
              src={fileUrl}
              alt="Receipt"
              style={{ maxWidth: "100%", height: "auto" }}
            />
          ) : fileType?.includes("pdf") ? (
            <embed
              src={fileUrl}
              type="application/pdf"
              style={{
                width: "100%",
                height: "80vh",
                border: "none",
              }}
            />
          ) : (
            <p>نوع فایل پشتیبانی نمی‌شود</p>
          )
        ) : (
          <p className=" w-[40rem]">در حال بارگذاری...</p>
        )}
      </div>
    </Modal>
  )
}

export default ImageView
